// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1kMU5","footer":"ModalInfo_footer__kXOfe"};